<template>
  <div id="mapContainer" class="basemap"></div>
</template>

<script>
import mapboxgl from "mapbox-gl";

export default {
  name: "BaseMap",
  data() {
    return {
      accessToken:
        "pk.eyJ1IjoicGF1bHhkMjciLCJhIjoiY2tidG9xbXM4MGJ2NjJ4bnN6YnBjcHNleiJ9.kWkFNonGBiW0TYwENTexWw",
    };
  },
  mounted() {
    mapboxgl.accessToken = this.accessToken;
    const nav = new mapboxgl.NavigationControl();

    let map = new mapboxgl.Map({
      container: "mapContainer",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [-102.59986361341, 22.7742783],
      zoom: 14,
    });

    map.addControl(nav, "top-right");
    map.scrollZoom.disable();

    const marker = new mapboxgl.Marker()
      .setLngLat([-102.59986361341, 22.7742783])
      .addTo(map);

    const geolocate = new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true,
      },
      trackUserLocation: true,
    });

  },
};
</script>

<style lang="scss" scoped>
.basemap {
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  max-width: 100%;
  max-height: 100%;
}
</style>
